module.exports = __webpack_public_path__ + "img/MENU.ba36c1d4.svg";